/*
  Task 9 follow-up (2026-10-01). The Split Payment app (Finloop/Spurit, "SPD Split Payment") renders its own
  note text in a real, confirmed element -- .spp2__widget-note (color #757575, per the app's own hosted
  common.css: cdn.finloop.solutions/shopify-apps/split-partial-payments-2/common.css) -- permanently, with
  no built-in show/hide toggle of its own (confirmed by reading, not guessing: the app's vendor CSS has no
  default-hidden rule for this class, unlike its separate .spp2__tooltip element, which does).
  This script does NOT touch the vendor script, the Split Payment button, or its popup -- it only ever
  selects the one confirmed class above, and only ever changes visibility, never removes or disables it.
  Event-driven (MutationObserver), not a timing-based retry loop: it reacts to the note actually appearing,
  whenever the app's own script gets around to rendering it, rather than guessing a delay.
*/
(function () {
  'use strict';

  function closeNote(note, trigger) {
    note.setAttribute('hidden', '');
    note.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.classList.remove('rx-split-info-trigger--open');
    document.removeEventListener('click', note._rxOutsideClick, true);
    document.removeEventListener('keydown', note._rxKeydown, true);
  }

  function openNote(note, trigger) {
    note.removeAttribute('hidden');
    note.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.classList.add('rx-split-info-trigger--open');
    note._rxOutsideClick = function (event) {
      if (!note.contains(event.target) && event.target !== trigger) {
        closeNote(note, trigger);
      }
    };
    note._rxKeydown = function (event) {
      if (event.key === 'Escape') {
        closeNote(note, trigger);
        trigger.focus();
      }
    };
    document.addEventListener('click', note._rxOutsideClick, true);
    document.addEventListener('keydown', note._rxKeydown, true);
  }

  function wireNote(note) {
    if (note.dataset.rxNoteWired) return;
    note.dataset.rxNoteWired = 'true';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'rx-split-info-trigger';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-label', 'Split Payment details');
    trigger.textContent = 'i';
    note.insertAdjacentElement('beforebegin', trigger);

    closeNote(note, trigger);

    trigger.addEventListener('click', function () {
      if (note.hasAttribute('hidden')) {
        openNote(note, trigger);
      } else {
        closeNote(note, trigger);
      }
    });
  }

  function scan(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.spp2__widget-note').forEach(wireNote);
  }

  scan(document);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.spp2__widget-note')) wireNote(node);
        scan(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
